import { createAction } from 'redux-actions';

import { CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST } from '../types';

export const clearWatchListEntriesByWatchListActions = createAction(CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/clearWatchListEntryByWatchListActions.js